<template>
  <div class="item_wrapper" v-on="$listeners">
    <div class="tip">
      <div class="text">
        vip {{ item.vipLevel }}
      </div>
    </div>
    <div class="top_info">
      <div class="id">
        {{ item.id }}

        <div class="icon" @click="onCopy(item.id)">
          <i class="el-icon-copy-document copy" />
        </div>
        <div :class="`ml-10 ${item.online === 1 ? 'success' : ''}`">
          {{ item.online === 1 ? 'Online' : 'Offline' }}
        </div>
      </div>
      <div :class="`${item.invite_num ? 'invite_num' : ''}`" @click="handleInvite(item)">
        {{ item.invite_num }}
      </div>
    </div>
    <div class="bottom_info l5">
      <div>
        <div>
          {{ $t("初始存款") }}: <span>{{ item.total_recharge_amount }}</span>
        </div>
        <div>
          {{ $t("有效投注") }}: <span>{{ item.total_bet_amount }}</span>
        </div>
        <div>
          {{ $t("状态") }}: <span :class="`${item.status === 1 ? 'success' : 'error'}`">{{ item.status === 1 ? $t("正常")
            : $t("禁止领取福利") }}</span>
        </div>
      </div>
      <div>
        <div>
          {{ $t("报名时间") }} <span>{{ item.createtime }}</span>
        </div>
        <div>
          {{ $t("上次登录") }} <span>{{ item.logintime }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  },
  methods: {
    onCopy(val) {
      let _this = this;
      this.$copyText(String(val)).then(
        function (e) {
          _this.$toast({
            background: "#07c160",
            message: _this.$t("复制成功"),
          });
        },
        function (e) {
        }
      );
    },
    handleInvite(item) {
      if (!item.invite_num) return
      this.$emit('hanldeInvite', item)
    }
  }
}
</script>
<style scoped lang="less">
@import '../../../assets/css/variables.less';

.item_wrapper {
  background-color: transparent !important;
}

.tip {
  position: absolute;
  left: 0;
  top: 0;
  width: fit-content;
  padding: 0.5px;
  background-color: #c12929;
  border-radius: 2px 2px 0;

  .text {
    padding: 0 2px;
    font-size: 6px;
    font-weight: 700;
    line-height: 1;
    -webkit-background-clip: text;
    background-clip: text;
    transform: skew(-14deg);
    -webkit-text-fill-color: transparent;
    background-image: linear-gradient(180deg, #f7ea94 -5%, #e5b952 58%, #ce9510 114%);
  }
}

.top_info {
  margin-bottom: 4px;
}

.top_info,
.bottom_info {
  display: flex;
  font-size: 11px;

  &>div {
    color: @textcolorf;
    width: 45%;

    span {
      color: @textcolor4;
      margin-left: 6px;
    }
  }
}

.id {
  display: flex;
  color: @rechargeColor;

  .icon {
    color: @rechargeColor;
    margin-left: 6px;
  }
}

.l5 {
  margin-top: 8px;

  &>div {
    width: 55%;
    font-size: 10px;
    line-height: 1.4;
  }

  &>div:first-child {
    width: 45%;
  }
}

.invite_num {
  color: @cursorColor !important;
  text-decoration: underline;
}

.success {
  color: @successColor !important;
}

.error {
  color: @errorColor !important;
}

.ml-10 {
  margin-left: 10px;
}
</style>